import * as React from "react";
import Grid from "@mui/material/Grid";
import { Autocomplete, CircularProgress, Dialog, TextField } from "@mui/material";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import WarningIcon from "@mui/icons-material/Warning";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { GlobalAppraisalPropertyTable } from "./GlobalAppraisalPropertyTable";
import { AppraisalReviewServiceURL, DocumentServiceURL, InvestmentServiceURL, LookupServieURL, TaskmgmtServiceURL } from "../../../config/config";
import { getApiCall, postApiCall } from "../../../services/apiHelper";
import { constants } from "buffer";
import { ServiceName } from "../../../constants";
import { wait } from "@testing-library/user-event/dist/utils";
import { useEffect, useState } from "react";
import { ViewTabList } from "../documents/ViewTabList";
import { useForm, Controller, FieldValues } from "react-hook-form";
import { Appraiser1, GlobalAppraisalModel, Properties, FundDDL } from "../../util/All_interfaces";
import dayjs, { Dayjs } from 'dayjs';
import axios, { AxiosError } from "axios";
import { ToastMessage } from "../../util/ToastMessage";
import { InvalidSelectionNewGlobalForm } from "./InvalidSelectionNewGlobalForm";
import { truncate } from "fs";
import { CurrentUser } from "../../../redux/slices/currentUserSlice";
import { useAppSelector } from "../../../redux/hooks";
import { UserContext, updateUserContext } from "../../../redux/slices/userContextSlice";
import { getProfile } from "../../../services/userContext";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { GlobalFund, updateSelectedGlobalFundAppraisal } from "../../../redux/slices/SelectedGlobalFundSlice";
import { ApplicationUser, AppraisalAttachment, DocumentTypesModel, FileChunk, UploadPreSignedPayloadModel } from "../../../all_Interfaces";
import { Appraiser } from "../../../redux/slices/Appraiser1Slice";
import { addNewAttachments } from "../../../redux/slices/AddNewAttachmentsSlice";
import { updateAttachments } from "../../../redux/slices/UpdateExistingAttachmentSlice";
import { ArgusSupportBanner } from "../../util/ArgusSupportBanner";
import { downloadGlobalProformaTemplate } from "./templates/GlobalProformaTemplate";

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export const GlobalAppraisalForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [expanded, setExpanded] = React.useState<string | false>("panel1");

  const [portfolioManager, setPortfolioManager] = useState({
    firstName: '',
    lastName: '',
    email: ''
  });

  const [assetManager, setAssetManager] = useState({
    firstName: '',
    lastName: '',
    email: ''
  });

  const [sectorHead, setSectorHead] = useState({
    firstName: '',
    lastName: '',
    email: ''
  });

  const [postFormdata, setPostFormData] = useState<GlobalAppraisalModel>(new GlobalAppraisalModel)

  const [postFormdataError, setPostFormdataError] = useState({
    fundName: false,
    appraiser1: false
  });
  const [propertyCurrencyErrors, setPropertyCurrencyErrors] = useState<boolean[]>([]);
  const [attachmentErrorDialog, setAttachmentErrorDialog] = useState<{ open: boolean; message: string; btnEvent: string }>({ open: false, message: "", btnEvent: "" });
  const fileSize = React.useRef<any>();
  const chunkSize = React.useRef<number>(1048576 * 3);
  const fileToBeUpload = React.useRef<any>();
  const chunkCount = React.useRef<any>();
  const chunk = React.useRef<any>();
  const fileGuid = React.useRef<any>();
  const counter = React.useRef<number>(1);
  const beginingOfTheChunk = React.useRef<number>(0);
  const endOfTheChunk = React.useRef<any>();
  const uploadStartResponse = React.useRef<any>();
  const largeFileCount = React.useRef<number>(0);

  const largeFileSuccessCount = React.useRef<number>(0);
  const largeFileFailedCount = React.useRef<number>(0);

  const [loading, setLoading] = useState(false);
  const [isGlobalFundFieldsEditable, setIsGlobalFundFieldsEditable] = useState<boolean>(false);
  const [isGermanFund, setIsGermanFund] = useState<boolean>(false);

  const [funds, setFunds] = useState<Array<{ id: number, fundID: string, fundName: string, region: string, createdBy: string }>>([]);
  const [internationalProperties, setInternationalProperties] = useState<Properties[] | []>([]);
  const [attachments, setAttachments] = useState<AppraisalAttachment[]>([]);

  const today = new Date();

  const [dateValue, setDateValue] = React.useState<string>(dayjs(today).format("MM-DD-YYYY"));

  const [appraiser1List, setAppraiser1List] = React.useState<Appraiser1[]>();
  const [appraiser1ListValue, setAppraiser1ListValue] = useState<any>([]);

  const [postDataMessage, setPostDataMessage] = useState<{ code: number | undefined, message: string, isError: boolean }>({ code: 0, message: "", isError: false });
  const [showInvalidPopup, setShowInvalidPopup] = useState<boolean>(false);
  const [appraisalId, setAppraisalId] = useState();
  const [docTypesData,setDocTypesData] = useState<DocumentTypesModel[]>([]);
  const [selectedAppraiser1, setSelectedAppraiser1] = useState<Appraiser1 | null>(null);

  const currentUserData: CurrentUser = useAppSelector((state) => state.currentUser.data);
  const userContext: UserContext = useAppSelector((state) => state.UserContext.data);
  const NewAttachmentList: AppraisalAttachment[] = useAppSelector(
    (state) => state.AddNewAttachments.data
  );

  const [fileMessage, setFileMessage] = useState<boolean>(false);
  const [isError, setIsError] = useState<{ isError: boolean; message: string }>(
    { isError: false, message: "" }
  );
  const [isSuccess, setIsSuccess] = useState<{
    isSuccess: boolean;
    message: string;
  }>({ isSuccess: false, message: "" });
  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  const invalidPopupClose = () => {
    window.location.reload()
    setShowInvalidPopup(false);
  }

  

  useEffect(() => {
    if (Object.keys(userContext).length == 0) {
      getProfile(true).then((data: any) => {
        dispatch(updateUserContext(data));
      });
    }
  }, []);

  useEffect(() => {
    setAttachments(NewAttachmentList);
  }, [NewAttachmentList]);

  const fetchData = async () => {
    dispatch(addNewAttachments([] as AppraisalAttachment[]));
    dispatch(updateAttachments([] as AppraisalAttachment[]));
    try{
      const [call1,call2]  = await Promise.all([
        getApiCall(`${TaskmgmtServiceURL}/Funds/getall`,
      ServiceName.TASKMANAGEMENTSERVICE),
      getApiCall(`${LookupServieURL}/DocumentTypes/GetAllEMEA`,
      ServiceName.LOOKUPSERVICE)
      ]);

      const data:any = call1 as any;

      let tempFundsArray = [];

        if (userContext.region != '') {
          tempFundsArray = data.result;
          if (userContext.region == 'US;EMEA') {
            tempFundsArray = tempFundsArray.filter((value: { region: string | string[]; }) => value.region?.includes('EMEA'));
          }
          else if (userContext.region == 'US;APAC') {
            tempFundsArray = tempFundsArray.filter((value: { region: string | string[]; }) => value.region?.includes('APAC'));
          }
          else if (userContext.region == 'US;EMEA;APAC') {
            tempFundsArray = tempFundsArray.filter((value: { region: string | string[]; }) => value.region?.includes('APAC') || value.region?.includes('EMEA'));
          }
          else if (userContext.region == 'EMEA;APAC') {
            tempFundsArray = tempFundsArray.filter((value: { region: string | string[]; }) => value.region?.includes('EMEA') || value.region?.includes('APAC'));
          }
          else {
            tempFundsArray = tempFundsArray.filter((value: { region: string | any[]; }) => value.region?.includes(userContext.region));
          }
        }
        else {
          tempFundsArray = data.result;
        }
        setFunds(tempFundsArray);


        const doctype: DocumentTypesModel[] = [...(call2 as any).result];
        setDocTypesData(doctype);
        setLoading(false);
        var d = dayjs(today);
        setDateValue(d.format("MM-DD-YYYY"));

        

    }catch(e:any){
      setLoading(false);
      console.log(e);
      
    }
  }

  const getExistingPendingAppraisals = async (fundID: any) => {
    await getApiCall(`${AppraisalReviewServiceURL}/globalappraisals/GetPendingGlobalAppraisalByFundId?fundId=${fundID}`,
      ServiceName.APPRAISALREVIEW).then((data: any) => {
        if (data.result.length !== 0)
        setAppraisalId(data.result.appraisalId);
        setShowInvalidPopup(true);
      }).catch((e: AxiosError) => {
        setLoading(false);
      });;
  }

  const getInvestmentByFundIdURL = async (value: any) => {
    await postApiCall(`${InvestmentServiceURL}/internationalproperty/GetByFundId?fundId=${value.fundID}`, "",
      ServiceName.INVESTMENTSERVICE).then(async (data: any) => {
        try {
          await getApiCall(`${AppraisalReviewServiceURL}/globalappraisals/GetIsGlobalFieldsEditableByFundId?fundid=${value.fundID}`,
            ServiceName.APPRAISALREVIEW).then((data:any) => {
              setIsGlobalFundFieldsEditable(data?.result);
              setIsGermanFund(data?.result);
            });
        }
        catch (e: any) {
          console.log("exception occurred in GetIsGlobalFieldsEditableByFundId", e);
        }


        if (data != null) {

          setPortfolioManager({
            firstName: data.result.portfolioManager == null ? "" : data.result.portfolioManager.firstName,
            lastName: data.result.portfolioManager == null ? "" : data.result.portfolioManager.lastName,
            email: data.result.portfolioManager == null ? "" : data.result.portfolioManager.email
          });

          setAssetManager({
            firstName: data.result.internationalProperties[0].assetManager == null ? "" : data.result.internationalProperties[0].assetManager.firstName,
            lastName: data.result.internationalProperties[0].assetManager == null ? "" : data.result.internationalProperties[0].assetManager.lastName,
            email: data.result.internationalProperties[0].assetManager == null ? "" : data.result.internationalProperties[0].assetManager.email
          });

          setSectorHead({
            firstName: data.result.internationalProperties[0].sectorHead == null ? "" : data.result.internationalProperties[0].sectorHead.firstName,
            lastName: data.result.internationalProperties[0].sectorHead == null ? "" : data.result.internationalProperties[0].sectorHead.lastName,
            email: data.result.internationalProperties[0].sectorHead == null ? "" : data.result.internationalProperties[0].sectorHead.email
          });

          var propertiesArray: Properties[] = [];
          propertiesArray = data.result.internationalProperties;

          const distinctProperties = propertiesArray.filter(
            (obj, index, array) =>
              array.findIndex(
                (p) => p.propertyType === obj.propertyType
              ) === index
          );

          let distinctPropertyTypes: string[] = [];
          distinctProperties.forEach((property) =>
            distinctPropertyTypes.push(property.propertyType)
          );

          const sortedDistinctPropertyTypes = distinctPropertyTypes.sort();

          let sortedPropertiesArray: Properties[] = [];

          sortedDistinctPropertyTypes.forEach((type) => {
            let sortedPropertyArray: Properties[] = [];
            propertiesArray.forEach((property) => {
              if (property.propertyType === type) {
                sortedPropertyArray.push(property);
              }
            });
            sortedPropertiesArray = sortedPropertiesArray.concat(
              sortedPropertyArray.sort((a, b) =>
                a.propertyName > b.propertyName ? 1 : -1
              )
            );
          });

          sortedPropertiesArray = sortedPropertiesArray.map(property => {            
            return {
                ...property,
                propertyValueDate: dayjs(new Date()).format("MM-DD-YYYY")
            };
        });

          
          
          setPostFormData({
            ...postFormdata, fundName: value.fundName, fundId: value.fundID,
            portfolioManager: {
              firstName: data.result.portfolioManager.firstName,
              lastName: data.result.portfolioManager.lastName,
              email: data.result.portfolioManager.email,
            },
            properties: sortedPropertiesArray,
            valueDate: dateValue,
            createdBy: userContext.displayName,
            status: "New"
          });

          setInternationalProperties(sortedPropertiesArray)
          getExistingPendingAppraisals(value.fundID);
          getAppraisal1List(value.fundID,data.result.appraiser1);
        } else {
          setIsError({message: `No Properties available for this Fund`, isError: true })
        }

        setLoading(false);

      }).catch((e: AxiosError) => {
        setIsError({message: `Record with id: ${value.fundID} does not exist.`, isError: true });
        setLoading(false);
      }).finally(()=>{
        wait(3000).then(()=>{
          setIsError({message:'',isError:false});
        })
      });
  }

  const getAppraisal1List = async (fundID: any, appraiser1:ApplicationUser) => {
    await getApiCall(`${TaskmgmtServiceURL}/userrolemaps/GetAppraisal1ListByFundId?isloader=0&fundId=${fundID}`,
      ServiceName.TASKMANAGEMENTSERVICE).then((data: any) => {

        let tempArray: Appraiser1[] = [{
          firstName: '',
          lastName: '',
          name: '',
          email: '',
          userType: ''
        }];

        let tempValueArray: string[] = [];

        data.result?.forEach((element: any) => {
          if (element.fundId.includes(fundID)) {
            tempArray.push({
              firstName: element.firstName,
              lastName: element.lastName,
              email: element.email,
              name: element.firstName + " " + element.lastName,
              userType: element.userType
            });

            tempValueArray.push(element.firstName + " " + element.lastName);
          }
        });


        tempArray.shift();

        tempArray = tempArray.sort((a, b) => {
          if (a.firstName === b.firstName) {
            return a.lastName.localeCompare(b.lastName)
          }
          return a.firstName.localeCompare(b.firstName)
        }).slice();

        // var a = tempArray.find((ele:Appraiser1) => ele.email.toLowerCase() == appraiser1.email.toLowerCase());
        // var apprsr1 = a != undefined ? a : new Appraiser1();
        // setSelectedAppraiser1(apprsr1);

        setAppraiser1List(tempArray);
        setAppraiser1ListValue(tempValueArray);
      });
  }

  const resetChunkProperties = () => {
    //setShowProgress(true);
    //setProgress(0);
    setCounter(1);
    beginingOfTheChunk.current = 0;
    endOfTheChunk.current = chunkSize.current;
  }

  const setCounter = (counterr: number) => {
    counter.current = counterr;
  } 

  const submitAttachment = async (data:any,btnEvent:string) => {

    let observableBatch: { promise: Promise<any>; doctype: string }[] = [];
    var tempAttachments = [...attachments];


        for (let i = 0; i < tempAttachments.length; i++) {
      setFileMessage(true);
      var tempFilePayload = new UploadPreSignedPayloadModel();
      tempFilePayload.doctype = tempAttachments[i].doctype;
      tempFilePayload.fileAsBase64 = tempAttachments[i].fileAsBase64;
      tempFilePayload.fileName = tempAttachments[i].fileName;
      tempFilePayload.fileSize = tempAttachments[i].fileSize;
      tempFilePayload.fileType = tempAttachments[i].fileType;
      tempFilePayload.guid = data.appraisalId;
      tempFilePayload.lastModifiedBy = tempAttachments[i].lastModifiedBy;
      tempFilePayload.lastModifiedDate = tempAttachments[i].lastModifiedDate;
      tempFilePayload.lastModifiedTime = tempAttachments[i].lastModifiedTime;
      tempFilePayload.scenarioId = data.scenarioId;


            if (tempFilePayload.fileSize < 26000000) {
                observableBatch.push({
                    promise: postApiCall(DocumentServiceURL + "/Documents/add",tempFilePayload,ServiceName.DOCUMENTSERVICE),
                    doctype: tempFilePayload.doctype
                });
            }
            else {

                largeFileCount.current++;
                await startFileChunkUpload(tempFilePayload);
            }
        }

        const results = await Promise.allSettled(observableBatch.map(item => item.promise));
        const failedUploads = results
            .map((result, index) => ({ result, doctype: observableBatch[index].doctype }))
            .filter(item => item.result.status === 'rejected');

        if (failedUploads.length > 0) {
            const proformaFailed = failedUploads.some(
                item => item.doctype?.toLowerCase() === "nvh valuation proforma"
            );
            if (proformaFailed) {
                throw { isProformaError: true, message: "The proforma format is incorrect. Please update the proforma as per the template here and upload the file again." };
            } else {
                throw { isProformaError: false, message: "One or more document uploads failed. Please try again." };
            }
        }

        console.log("Direct upload document was saved Successfully");
        await waitForLargeFileToBeUploaded(btnEvent,data.appraisalId);

  };

  const startFileChunkUpload = async (file:any) => {

		fileSize.current = file.fileSize;

		const _totalCount = fileSize.current % chunkSize.current == 0 ? fileSize.current / chunkSize.current : Math.floor(fileSize.current / chunkSize.current) + 1; // Total count of chunks will have been upload to finish the file
		chunkCount.current = _totalCount;

		//let tmpDirectoryName = {tmpDirectoryName:file.guid};
		let chunkFile = new FileChunk();
		chunkFile.fileAsBase64 = "";

		chunkFile.tmpDirectory = file.guid;
		chunkFile.fileName = file.fileName;

		return await postApiCall(DocumentServiceURL + "/Documents/start",chunkFile,ServiceName.DOCUMENTSERVICE).then(async (data: any) => {
				console.log('success', data);
				uploadStartResponse.current = data;
				await fileUpload(file, uploadStartResponse.current);

				return uploadStartResponse.current;
			}
		).catch((e:any)=> {
      console.log("Chunk Upload error ",e);
      
    }).then((d:any)=>{
      console.log("Complete");
    });
	}

  const fileUpload = async (file, uploadStartResponse) => {
		endOfTheChunk.current = chunkSize.current ;
		while (beginingOfTheChunk.current  <= file.fileAsBase64.length) {

			var chunk = file.fileAsBase64.slice(beginingOfTheChunk.current , endOfTheChunk.current );


			let chunkFile = new FileChunk();
			chunkFile.fileAsBase64 = chunk;

			chunkFile.tmpDirectory = uploadStartResponse.tmpDirectoryName;
			chunkFile.fileName = file.fileName;
			chunkFile.fileSize = file.size;
			chunkFile.lastModifiedTime = file.lastModifiedTime;
			chunkFile.lastModifiedDate = file.lastModifiedDate;
			chunkFile['estUploadDate'] = file.estUploadDate;
			chunkFile.lastModifiedBy = file.lastModifiedBy;
			chunkFile.fileIndex = counter.current;

			let responseData = await uploadChunk(chunkFile);

			setCounter(counter.current  + 1);
			beginingOfTheChunk.current  = endOfTheChunk.current ;
			endOfTheChunk.current  = endOfTheChunk.current  + chunkSize.current ;

		}
		uploadCompleted(uploadStartResponse, file);

	}

  const uploadChunk = async (chunkFile: any): Promise<any> => {
		try {

			return await postApiCall(DocumentServiceURL + "/Documents/chunk",chunkFile,ServiceName.DOCUMENTSERVICE).then(
				(data:any) => {
					console.log('success', data);
					return true;
				},
				(error:any) => {
					console.error('error', error);
					return false;

				}
			);


		} catch (error) {

			console.log('error', error)
		}
	}


  const uploadCompleted = async (uploadStartResponse, file)  => {
		let chunkFile = new FileChunk();
		chunkFile.fileAsBase64 = "";

		chunkFile.tmpDirectory = uploadStartResponse.tmpDirectoryName;
		chunkFile.fileName = file.fileName;
		chunkFile.guid = file.guid;
		chunkFile.doctype = file.doctype;
		chunkFile.fileSize = file.fileSize;

		chunkFile.lastModifiedTime = file.lastModifiedTime;
		chunkFile.lastModifiedDate = file.lastModifiedDate;
		chunkFile.lastModifiedBy = file.lastModifiedBy;


		return await postApiCall(DocumentServiceURL + "/Documents/end",chunkFile,ServiceName.DOCUMENTSERVICE).then( (data: any) => {
				console.log('success', data);
				let uploadEndResponse = data;
				largeFileSuccessCount.current++;
				return data;

			}
      // ,
			// error: (error: any) => {
			// 	console.error('error', error);
			// 	this.largeFileFailedCount++;
			// 	return error;

			// }
		).catch((e:any)=> {
      console.log("Chunk Upload error ",e);
      
    }).then((d:any)=>{
      console.log("Complete");
    });
	}


  const waitForLargeFileToBeUploaded = async (btnEvent,appraisalId:string) => {
		while (largeFileCount.current != largeFileSuccessCount.current + largeFileFailedCount.current) {
			await wait(2000);
		}
		setIsSuccess({ isSuccess: true, message: `Appraisal has been ${btnEvent == 'submit' ? 'submitted' : 'saved'}` });
    wait(5000).then(() => {
          setFileMessage(false);
              setIsSuccess({ isSuccess: false, message: '' });
              setIsError({ isError: false, message: '' });
              navigate('/global/global-equity/edit/' + appraisalId);            }); 
	}

  const convertToSimpleNumber = (input:any) : number | string | null => {
    if(input != null && input != undefined){
    const sanitizedString = input.replace(/,/g, '');
    const numberValue = Number(sanitizedString);
    return isNaN(numberValue) ? null : numberValue;
    }
    else {
      return null;
    }
  }

  const postSaveForm = async () => {
    setLoading(true);
    var propertiesPayloadTemp:Properties[] = [...postFormdata.properties];
    var propertiesPayload:Properties[] = [];
    propertiesPayloadTemp.forEach((property:Properties,index:number) => {
      propertiesPayload.push({...property,
          netRentPassing: convertToSimpleNumber(property.netRentPassing),
          rentalValue: convertToSimpleNumber(property.rentalValue),
          grossValue: convertToSimpleNumber(property.grossValue),
          capitalExpenditure: convertToSimpleNumber(property.capitalExpenditure),
          acquisitionCosts: convertToSimpleNumber(property.acquisitionCosts),
          netValue: convertToSimpleNumber(property.netValue),
          sayValue: convertToSimpleNumber(property.sayValue),       
          assumedHoldingPeriod: convertToSimpleNumber(property.assumedHoldingPeriod),   
          netExitValue: convertToSimpleNumber(property.netExitValue),
          terminalCapRate: convertToSimpleNumber(property.terminalCapRate) ?? 0,
          discountRate: convertToSimpleNumber(property.discountRate) ?? 0,
          propertyValueDate: isGlobalFundFieldsEditable ? property.propertyValueDate : postFormdata.valueDate,
      })
    });

    var payload:GlobalAppraisalModel = {...postFormdata,
      numOfTenants:convertToSimpleNumber(postFormdata.numOfTenants),
      sayValue :convertToSimpleNumber(postFormdata.sayValue),
      netValue:convertToSimpleNumber(postFormdata.netValue),
      netRentPassing:convertToSimpleNumber(postFormdata.netRentPassing),
      acquisitionCosts:convertToSimpleNumber(postFormdata.acquisitionCosts),
      capitalExpenditure:convertToSimpleNumber(postFormdata.capitalExpenditure),
      grossValue:convertToSimpleNumber(postFormdata.grossValue),
      rentalValue:convertToSimpleNumber(postFormdata.rentalValue),
      properties:propertiesPayload
    };



    await postApiCall(`${AppraisalReviewServiceURL}/globalappraisals/Save`, payload,
      ServiceName.APPRAISALREVIEW).then(async (data: any) => {
        setPostFormData({
          ...postFormdata,appraisalId:data.result.value.appraisalId});
        try {
          await submitAttachment(data.result.value,'save');
          setFileMessage(false);
          setIsSuccess({ message: "Appraisal Has Been Saved", isSuccess: true });
          setLoading(false);
        } catch (attachErr: any) {
          setLoading(false);
          setFileMessage(false);
          if (attachErr?.isProformaError) {
            const errMsg = "The proforma format is incorrect. Please update the proforma as per the template here and upload the file again.";
            setAttachmentErrorDialog({ open: true, message: errMsg, btnEvent: 'save' });
          } else {
            setIsError({ message: attachErr?.message || "Document upload failed. Please try again.", isError: true });
          }
          return;
        }
        
      }).catch((e: AxiosError) => {
        setLoading(false);
        setIsError({ message: "Appraisal could not be saved", isError: true });
      }).finally(() => {
        wait(3000).then(() => {
          setIsError({message: "", isError: false });
          setIsSuccess({ message: "", isSuccess: false });

        });
      })
  }

  const handleFundNameChange = (value: any) => {
    if (value != null) {
      setLoading(true);
      getInvestmentByFundIdURL(value);
      dispatch(updateSelectedGlobalFundAppraisal({ region: value.region, fundId: value.fundID, fundName: value.fundName } as unknown as GlobalFund));
      setTimeout(() => { setPostDataMessage({ code: 0, message: "", isError: false }); }, 1500);
      
      setPostFormdataError({ ...postFormdataError, fundName: false });
    } else {
      setPostFormData({
        ...postFormdata, fundName: '', fundId: '', appraiser1: { firstName: '', lastName: '', email: '' },
        portfolioManager: { firstName: '', lastName: '', email: '' }
      });
      setShowInvalidPopup(false);
      dispatch(updateSelectedGlobalFundAppraisal({ region: "", fundId: "", fundName: "" } as unknown as GlobalFund));
      setAppraiser1List([]);
      setAppraiser1ListValue([]);
      setInternationalProperties([])
      setPostFormdataError({ ...postFormdataError, fundName: true, appraiser1: true });
    }
  }

  const handleAppraiser1Change = (value: Appraiser1) => {
    if (value != null && appraiser1List != undefined) {
      var abc = appraiser1List;
      var cbc = abc.filter(elm => elm.email == value.email);

      setPostFormData({
        ...postFormdata,
        appraiser1: { firstName: cbc[0].firstName, lastName: cbc[0].lastName, email: cbc[0].email }
      });

      setSelectedAppraiser1(value);
      setPostFormdataError({ ...postFormdataError, appraiser1: false });
    } else {
      setSelectedAppraiser1(null);
      setPostFormData({ ...postFormdata, appraiser1: { firstName: '', lastName: '', email: '' } });
      setPostFormdataError({ ...postFormdataError, appraiser1: true });
    }
  }

  const hasAnyNumericValue = (property: Properties): boolean => {
    const numericFields = [
      property.rentalValue, property.netRentPassing, property.grossValue,
      property.capitalExpenditure, property.acquisitionCosts, property.netValue,
      property.sayValue, property.initialYieldValuation, property.initialYieldContracted,
      property.nominalEquivalentYield, property.trueEquivalentYield, property.reversionaryYield,
      property.terminalCapRate, property.discountRate, property.assumedHoldingPeriod,
      property.growthRates, property.netExitValue, property.forwardInitialYield,
    ];
    return numericFields.some(v => {
      if (v === null || v === undefined || v === '') return false;
      const num = Number(String(v).replace(/,/g, ''));
      return !isNaN(num) && num !== 0;
    });
  };

  const saveForm = () => {
    if (postFormdata.fundName.length === 0 ||
      postFormdata.appraiser1 == undefined || postFormdata.appraiser1 == null || postFormdata.appraiser1.email == "") {
      setIsError({ message: "Please correct the validation errors!", isError: true });
      wait(3000).then(() => { setIsError({ message: "", isError: false }); });
      return;
    }

    const currencyErrors = postFormdata.properties.map(
      (p) => hasAnyNumericValue(p) && (!p.currency || p.currency.trim() === '')
    );
    setPropertyCurrencyErrors(currencyErrors);
    const hasCurrencyError = currencyErrors.some(Boolean);

    if (hasCurrencyError) {
      setIsError({ message: "Currency is required for properties with numeric values!", isError: true });
      wait(3000).then(() => { setIsError({ message: "", isError: false }); });
      return;
    }

    setIsError({ message: "", isError: false });
    postSaveForm();
  }

  useEffect(() => {
    setLoading(true);
    if (Object.keys(userContext).length != 0) {
      fetchData();

    }

  }, [userContext]);
  const { control, handleSubmit } = useForm({});


  const handleEffectiveDateOfValue = (d: Dayjs | null) => {
    if (d != null) {
      setDateValue(d.format("MM-DD-YYYY")); 
      setPostFormData({ ...postFormdata, valueDate: d.format("MM-DD-YYYY") });
    }
  };

  const formatNumberWithCommas = (num: number | string | null) => {
    if(num != null)
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',').replace(/(?<=\.\d*?),/g,'');
    return "";
  }

  const handlePropertyValuedate = (d: Dayjs | null, i: any) => {
    if (d != null) {
      var tempRows = [...postFormdata.properties];
      tempRows[i] = { ...tempRows[i], propertyValueDate: d.format("MM-DD-YYYY") };
      setPostFormData({ ...postFormdata, properties: tempRows })
    }
  }

  const handleRentalValue = (value: any, i: any) => {
    const plainNumber = value.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);
      var tempRows2 = [...postFormdata.properties];
      tempRows2[i] = { ...tempRows2[i], rentalValue: formatedValue };
      setPostFormData({ ...postFormdata, properties: tempRows2 });
    }
  }

  const handleNetrentpassing = (value: any, i: any) => {
    const plainNumber = value.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);
      var tempRows2 = [...postFormdata.properties];
      tempRows2[i] = { ...tempRows2[i], netRentPassing: formatedValue };
      setPostFormData({ ...postFormdata, properties: tempRows2 });
    }
  }
  const handleGrossvalue = (value: any, i: any) => {
    const plainNumber = value.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);
      var tempRows2 = [...postFormdata.properties];
      tempRows2[i] = { ...tempRows2[i], grossValue: formatedValue };
      setPostFormData({ ...postFormdata, properties: tempRows2 });
    }
  }
  const handleCapitalexpenditure = (value: any, i: any) => {
    const plainNumber = value.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);
      var tempRows2 = [...postFormdata.properties];
      tempRows2[i] = { ...tempRows2[i], capitalExpenditure: formatedValue };
      setPostFormData({ ...postFormdata, properties: tempRows2 });
    }
  }
  const handleAcquisitioncosts = (value: any, i: any) => {
    const plainNumber = value.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);
      var tempRows2 = [...postFormdata.properties];
      tempRows2[i] = { ...tempRows2[i], acquisitionCosts: formatedValue };
      setPostFormData({ ...postFormdata, properties: tempRows2 });
    }
  }
  const handleNetvalue = (value: any, i: any) => {
    const plainNumber = value.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);
      var tempRows2 = [...postFormdata.properties];
      tempRows2[i] = { ...tempRows2[i], netValue: formatedValue };
      setPostFormData({ ...postFormdata, properties: tempRows2 });
    }
  }
  const handleSayvalue = (value: any, i: any) => {
    const plainNumber = value.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);
      var tempRows2 = [...postFormdata.properties];
      tempRows2[i] = { ...tempRows2[i], sayValue: formatedValue };
      setPostFormData({ ...postFormdata, properties: tempRows2 });
    }
  }
  const handleInitialyieldvaluation = (value: any, i: any) => {
    const plainNumber = value.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);
      var tempRows2 = [...postFormdata.properties];
      tempRows2[i] = { ...tempRows2[i], initialYieldValuation: (plainNumber) };
      setPostFormData({ ...postFormdata, properties: tempRows2 });
    }
  }
  const handleInitialyieldcontracted = (value: any, i: any) => {
    const plainNumber = value.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);
      var tempRows2 = [...postFormdata.properties];
      tempRows2[i] = { ...tempRows2[i], initialYieldContracted: (plainNumber) };
      setPostFormData({ ...postFormdata, properties: tempRows2 });
    }
  }
  const handleNominalequivalentyield = (value: any, i: any) => {
    const plainNumber = value.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);
      var tempRows2 = [...postFormdata.properties];
      tempRows2[i] = { ...tempRows2[i], nominalEquivalentYield: (plainNumber) };
      setPostFormData({ ...postFormdata, properties: tempRows2 });
    }
  }
  const handleTrueequivalentyield = (value: any, i: any) => {
    const plainNumber = value.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);
      var tempRows2 = [...postFormdata.properties];
      tempRows2[i] = { ...tempRows2[i], trueEquivalentYield: (plainNumber) };
      setPostFormData({ ...postFormdata, properties: tempRows2 });
    }
  }
  const handleReversionaryyield = (value: any, i: any) => {
    const plainNumber = value.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);
      var tempRows2 = [...postFormdata.properties];
      tempRows2[i] = { ...tempRows2[i], reversionaryYield: (plainNumber) };
      setPostFormData({ ...postFormdata, properties: tempRows2 });
    }
  }
  const handleAssumedholdingperiod = (value: any, i: any) => {
    const plainNumber = value.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);
      var tempRows2 = [...postFormdata.properties];
      tempRows2[i] = { ...tempRows2[i], assumedHoldingPeriod: formatedValue };
      setPostFormData({ ...postFormdata, properties: tempRows2 });
    }
  }
  const handleDiscountrate = (value: any, i: any) => {
    const plainNumber = value.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);
      var tempRows2 = [...postFormdata.properties];
      tempRows2[i] = { ...tempRows2[i], discountRate: (plainNumber) };
      setPostFormData({ ...postFormdata, properties: tempRows2 });
    }
  }
  const handleForwardinitialyield = (value: any, i: any) => {
    const plainNumber = value.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);
      var tempRows2 = [...postFormdata.properties];
      tempRows2[i] = { ...tempRows2[i], forwardInitialYield: (plainNumber) };
      setPostFormData({ ...postFormdata, properties: tempRows2 });
    }
  }
  const handleGrowthrates = (value: any, i: any) => {
    const plainNumber = value.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);
      var tempRows2 = [...postFormdata.properties];
      tempRows2[i] = { ...tempRows2[i], growthRates: (plainNumber) };
      setPostFormData({ ...postFormdata, properties: tempRows2 });
    }
  }
  const handleNetexitvalue = (value: any, i: any) => {
    const plainNumber = value.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);
      var tempRows2 = [...postFormdata.properties];
      tempRows2[i] = { ...tempRows2[i], netExitValue: formatedValue };
      setPostFormData({ ...postFormdata, properties: tempRows2 });
    }
  }
  const handleTerminalCapRate = (value: any, i: any) => {
    const plainNumber = value.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);
      var tempRows2 = [...postFormdata.properties];
      tempRows2[i] = { ...tempRows2[i], terminalCapRate: (plainNumber) };
      setPostFormData({ ...postFormdata, properties: tempRows2 });
    }
  }

  const handleCurrency = (value: any, i: any) => {
    var tempRows2 = [...postFormdata.properties];
    tempRows2[i] = { ...tempRows2[i], currency: value };
    setPostFormData({ ...postFormdata, properties: tempRows2 });
    if (value && value.trim() !== '') {
      setPropertyCurrencyErrors(prev => {
        const updated = [...prev];
        updated[i] = false;
        return updated;
      });
    }
  }


  const handleFundNoOfTenants = (value:any) => {
    const plainNumber = value.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);
      setPostFormData({ ...postFormdata, numOfTenants:formatedValue });
    }
  }
  const handleFundSayValue = (value:any) => {
    const plainNumber = value.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);
      setPostFormData({ ...postFormdata, sayValue:formatedValue });
    }
  }  
  const handleFundNetValue = (value:any) => {
    const plainNumber = value.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);
      setPostFormData({ ...postFormdata, netValue:formatedValue });
    }
  }  
  const handleFundNetRentPassing = (value:any) => {
    const plainNumber = value.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);
      setPostFormData({ ...postFormdata, netRentPassing:formatedValue });
    }
  }
  const handleFundAcquisitionCost = (value:any) => {
    const plainNumber = value.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);
      setPostFormData({ ...postFormdata, acquisitionCosts:formatedValue });
    }
  }  
  const handleFundCapitalExpenditure = (value:any) => {
    const plainNumber = value.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);
      setPostFormData({ ...postFormdata, capitalExpenditure:formatedValue });
    }
  }  
  const handleFundGrossValue = (value:any) => {
    const plainNumber = value.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);
      setPostFormData({ ...postFormdata, grossValue:formatedValue });
    }
  }  
  const handleFundRentalValue = (value:any) => {
    const plainNumber = value.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);
      setPostFormData({ ...postFormdata, rentalValue:formatedValue });
    }
  }  
  return (
    <>
      <ArgusSupportBanner />
      {showInvalidPopup ? <InvalidSelectionNewGlobalForm closePopup={invalidPopupClose} appraisalId={appraisalId} /> : null}
      <div className="form-wrap">
      {isError.isError && (
        <ToastMessage message={isError.message} severity="error" />
      )}
      {isSuccess.isSuccess && (
        <ToastMessage message={isSuccess.message} severity="success" />
      )}
        <Dialog
            open={attachmentErrorDialog.open}
            onClose={() => {
                setAttachmentErrorDialog({ open: false, message: "", btnEvent: "" });
            }}
            PaperProps={{
                sx: {
                    borderRadius: "12px",
                    minWidth: "450px",
                    maxWidth: "500px",
                    position: "relative",
                    padding: "40px 32px 32px",
                },
            }}
        >
            <IconButton
                size="small"
                onClick={() => {
                    setAttachmentErrorDialog({ open: false, message: "", btnEvent: "" });
                }}
                sx={{ position: "absolute", top: 8, right: 8, color: "#9e9e9e" }}
                aria-label="close"
            >
                <CloseIcon fontSize="small" />
            </IconButton>
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
                <WarningIcon sx={{ fontSize: 52, color: "#f44336", mb: 2 }} />
                <Typography sx={{ fontWeight: 600, fontSize: "1.15rem", color: "#212121", mb: 1.5 }}>
                    We are saving your appraisal, but the proforma is incorrect
                </Typography>
                <Typography sx={{ fontSize: "0.875rem", color: "#757575", lineHeight: 1.8 }}>
                    Please update the proforma as per the template  
                </Typography>
                <Typography sx={{ fontSize: "0.875rem", color: "#757575" }}>
                    <a
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            downloadGlobalProformaTemplate();
                            setAttachmentErrorDialog({ open: false, message: "", btnEvent: "" });
                        }}
                        style={{ color: "#1976d2", cursor: "pointer", textDecoration: "underline" }}
                    >
                        here
                    </a>
                    {" "}before submitting the appraisal.
                </Typography>
            </Box>
        </Dialog>
        {postDataMessage.isError ?
          <ToastMessage message={postDataMessage.message} severity="error" />
          : null}
        {postDataMessage.code == 200 ?
          <ToastMessage message={postDataMessage.message} severity="success" />
          : null}
        <Box sx={{ width: "100%", typography: "body1" }}>
          {loading ? (
            <div className="overlaySpinner">
              <CircularProgress />
            </div>
          ) : null}
          {fileMessage && (
            <div className="overlaySpinner">
              { fileMessage  && <><span>File upload is in progress... &nbsp;  </span>
              <CircularProgress /></> }
            </div>
          )}
          <h3 className="heading">Fund Details :</h3>
          <Grid container spacing={3}>
            <Grid item xs={6} sm={6}>
              <Controller
                name="fundName"
                control={control}
                render={({ field }) => (
                  <Autocomplete
                    id="fund-id"
                    options={funds}
                    getOptionLabel={(option) => `${option.fundID} : ${option.fundName}`}
                    onChange={(event: any, value: any) => {
                      handleFundNameChange(value);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Fund Name"
                        size="small"
                        required
                        InputLabelProps={{
                          sx:{
                              '& .MuiInputLabel-asterisk' : {
                                color:'red',
                              },
                          },
                        }}
                        error={postFormdataError.fundName}
                      />
                    )}
                  />
                )}
              />
            </Grid>

            <Grid item xs={6} sm={6}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                label={`Portfolio Manager`}
                value={postFormdata.portfolioManager != null ? postFormdata.portfolioManager.firstName + ", " + postFormdata.portfolioManager.lastName : ""}
                className="Autopopulatefield"
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <Controller
                name="appraiser1"
                control={control}
                render={({ field }) => (
                  <Autocomplete
                    id="fund-id"
                    options={appraiser1List || []}
                    getOptionLabel={(option) => {
                      return option.firstName + " " + option.lastName;
                    }}
                    value={selectedAppraiser1}
                    onChange={(event: any, value: any) => {
                      handleAppraiser1Change(value);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Appraiser 1"
                        size="small"
                        required
                        InputLabelProps={{
                          sx:{
                              '& .MuiInputLabel-asterisk' : {
                                color:'red',
                              },
                          },
                        }}
                        error={postFormdataError.appraiser1}
                      />
                    )}
                  />
                )}
              />
            </Grid>

            <Grid item xs={6} sm={6} sx={{ marginTop: "-5px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={["DatePicker", "DatePicker", "DatePicker"]}
                >
                  <DatePicker
                    name="startDate"
                    sx={{ width: 300 }}
                    format="MMM-DD-YYYY"
                    slotProps={{ textField: { size: "small" } }}
                    label="Effective Date of Value"
                    value={ dateValue === "" ||
                    dateValue == null
                    ? null
                    : dayjs(
                      dateValue,
                      "MM-DD-YYYY"
                    )}
                    views={["month", "day", "year"]}
                    onChange={(newValue: Dayjs | null) =>
                      handleEffectiveDateOfValue(newValue)
                    }
                  />
                </DemoContainer>
              </LocalizationProvider>
            </Grid>
          </Grid>
        </Box>
        <Divider className="divider-line"></Divider>
        <Box sx={{ width: "100%", typography: "body1" }}>
          <h3 className="heading">Argus Details :</h3>
          <Grid container spacing={3}>
            <Grid item xs={6} sm={6}>
              <TextField
                label="No. of Tenants"
                inputProps={{
                  readOnly:!isGlobalFundFieldsEditable,
                }}
                variant="outlined"
                value={postFormdata.numOfTenants}
                onChange={(e) => handleFundNoOfTenants(e.target.value)}
                size="small"
                fullWidth
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <TextField
                label="Net Rent Passing"
                inputProps={{
                  readOnly:!isGlobalFundFieldsEditable,
                }}
                variant="outlined"
                value={postFormdata.netRentPassing}
                onChange={(e) => handleFundNetRentPassing(e.target.value)}                
                size="small"
                fullWidth
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <TextField
                label="Rental Value"
                inputProps={{
                  readOnly:!isGlobalFundFieldsEditable,
                }}
                variant="outlined"
                value={postFormdata.rentalValue}
                onChange={(e) => handleFundRentalValue(e.target.value)}
                size="small"
                fullWidth
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <TextField
                label="Gross Value"
                inputProps={{
                  readOnly:!isGlobalFundFieldsEditable,
                }}
                variant="outlined"
                value={postFormdata.grossValue}
                onChange={(e) => handleFundGrossValue(e.target.value)}
                size="small"
                fullWidth
              />
            </Grid>

            <Grid item xs={6} sm={6}>
              <TextField
                label="Capital Expenditure"
                inputProps={{
                  readOnly:!isGlobalFundFieldsEditable,
                }}
                variant="outlined"
                value={postFormdata.capitalExpenditure}
                onChange={(e) => handleFundCapitalExpenditure(e.target.value)}
                size="small"
                fullWidth
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <TextField
                label="Acquisition Costs "
                inputProps={{
                  readOnly:!isGlobalFundFieldsEditable,
                }}
                variant="outlined"
                value={postFormdata.acquisitionCosts}
                onChange={(e) => handleFundAcquisitionCost(e.target.value)}
                size="small"
                fullWidth
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <TextField
                label="Net Value"
                placeholder="Net Value"
                inputProps={{
                  readOnly:!isGlobalFundFieldsEditable,
                }}
                variant="outlined"
                value={postFormdata.netValue}
                onChange={(e) => handleFundNetValue(e.target.value)}
                size="small"
                fullWidth
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <TextField
                label="Say Value"
                inputProps={{
                  readOnly:!isGlobalFundFieldsEditable,
                }}
                variant="outlined"
                value={postFormdata.sayValue}
                onChange={(e) => handleFundSayValue(e.target.value)}
                size="small"
                fullWidth
              />
            </Grid>
          </Grid>
        </Box>
        <Divider className="divider-line"></Divider>
        <Box
          sx={{ width: "100%", typography: "body1" }}
          className="accordion-wrap"
        >
          <Accordion defaultExpanded>
            <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
              <Typography>Property Level Details</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <GlobalAppraisalPropertyTable 
                isEditable={isGlobalFundFieldsEditable} 
                isGermanFund={isGermanFund}
                currentData={postFormdata.properties} 
                priorProperties={[]} 
                editDisplay={false} 
                handleRentalValue= {handleRentalValue}
                handleNetrentpassing = {handleNetrentpassing}
                handleGrossvalue = {handleGrossvalue}
                handleCapitalexpenditure = {handleCapitalexpenditure}
                handleAcquisitioncosts = {handleAcquisitioncosts}
                handleNetvalue = {handleNetvalue}
                handleSayvalue = {handleSayvalue}
                handleInitialyieldvaluation = {handleInitialyieldvaluation}
                handleInitialyieldcontracted = {handleInitialyieldcontracted}
                handleNominalequivalentyield = {handleNominalequivalentyield}
                handleTrueequivalentyield = {handleTrueequivalentyield}
                handleReversionaryyield = {handleReversionaryyield}
                handleAssumedholdingperiod = {handleAssumedholdingperiod}
                handleDiscountrate = {handleDiscountrate}
                handleForwardinitialyield = {handleForwardinitialyield}
                handleGrowthrates = {handleGrowthrates}
                handleNetexitvalue = {handleNetexitvalue}
                handleTerminalCapRate = {handleTerminalCapRate}
                handlePropertyValuedate={handlePropertyValuedate}
                handleCurrency = {handleCurrency}
                currencyErrors={propertyCurrencyErrors}
               />
            </AccordionDetails>
          </Accordion>

          <Accordion defaultExpanded>
            <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
              <Typography>Documents</Typography>
            </AccordionSummary>
            <AccordionDetails className="upload-document">
              {docTypesData.length != 0 && (
                <ViewTabList tabData={docTypesData} />
              )}
            </AccordionDetails>
          </Accordion>
        </Box>
        <Box sx={{ padding: "15px 2px" }}>
          <Grid item xs={12}>
            <Button sx={{textTransform:"none"}} variant="contained" size="medium" color="success" disabled={showInvalidPopup} onClick={() => {
              saveForm();
              setPostFormdataError({
                ...postFormdataError,
                fundName: postFormdata.fundName.length === 0,
                appraiser1: postFormdata.appraiser1 == undefined ||  postFormdata.appraiser1 == null || postFormdata.appraiser1.email == "",
              });

            }}>
              Save
            </Button>
            <Button sx={{textTransform:"none",ml: 2}} variant="outlined" size="medium" color="error">
              Close
            </Button>
          </Grid>
        </Box>
      </div>
    </>
  );
};
